import {
  GET_ALL_STATIC_PAGES,
  GET_ALL_STATIC_PAGES_RESPONSE_SUCCESS,
  CREATE_STATIC_PAGE,
  UPDATE_STATIC_PAGE,
  DELETE_STATIC_PAGE,
} from "./actionTypes"

export const getAllStaticPages = () => {
  return {
    type: GET_ALL_STATIC_PAGES,
  }
}
export const getAllStaticPagesResponseSuccess = payload => ({
  type: GET_ALL_STATIC_PAGES_RESPONSE_SUCCESS,
  payload: payload,
})

// ------------------------------------- CREATE --------------------------------------------------------

export const createStaticPage = (payload, history) => {
  return {
    type: CREATE_STATIC_PAGE,
    payload: payload,
    history,
  }
}

// ------------------------------------- EDIT --------------------------------------------------------

export const updateStaticPage = (payload, history, redirectTo) => {
  return {
    type: UPDATE_STATIC_PAGE,
    payload: payload,
    history,
    redirectTo,
  }
}

// ------------------------------------- DELETE --------------------------------------------------------

export const deleteStaticPage = payload => ({
  type: DELETE_STATIC_PAGE,
  payload: payload,
})
